import React from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export default function EstatusActualDeSolicitud(estatus) {
    const history = useHistory();

    let copyEnProceso = "Su solicitud continúa en proceso de aprobación, una vez finalizada te notificaremos el estatus de tu petición.";
    let copyRechazada = "Su solicitud ha sido rechazada, puedes acudir a cualquier tienda SEARS para solicitar nuevamente tu crédito.";

    // redirecciona a home
    const redireccionHome = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}`);
    };

    return (
        <>
            <div className="contenedorGeneral">

                {String(estatus.estatus).toLowerCase() === "aprobada" || String(estatus.estatus).toLowerCase() === "autorizada"
                    ? <div className="boxES">
                        <div className="boxIconES">
                            <img src={`${BASE_PATH}${SUB_DIRECTORY}img/checkMark.png`} alt="solicitud-ok"></img>
                        </div>

                        <div className="boxCopysES">
                            <h4>Aprobada</h4>

                            <div className="boxBtnEnterado">
                                <button onClick={redireccionHome}>Enterado</button>
                            </div>
                        </div>
                    </div>
                    : String(estatus.estatus).toLowerCase() === "en proceso"
                        ? <div className="boxES">
                            <div className="boxIconES">
                                <img src={`${BASE_PATH}${SUB_DIRECTORY}img/alert.png`} alt="solicitud-en-proceso"></img>
                            </div>

                            <div className="boxCopysES">
                                <h4>En proceso</h4>
                                <p>{copyEnProceso}</p>

                                <div className="boxBtnEnterado">
                                    <button onClick={redireccionHome}>Enterado</button>
                                </div>
                            </div>
                        </div>
                        : String(estatus.estatus).toLowerCase() === "rechazada"
                            ? <div className="boxES">
                                <div className="boxIconES">
                                    <img src={`${BASE_PATH}${SUB_DIRECTORY}img/remove.png`} alt="solicitud-rechazada"></img>
                                </div>

                                <div className="boxCopysES">
                                    <h4>Rechazada</h4>
                                    <p>{copyRechazada}</p>

                                    <div className="boxBtnEnterado">
                                        <button onClick={redireccionHome}>Enterado</button>
                                    </div>
                                </div>
                            </div>
                            :
                                <div className="boxES">
                                    <div className="boxIconES">
                                        <img src={`${BASE_PATH}${SUB_DIRECTORY}img/alert.png`} alt="solicitud-en-proceso"></img>
                                    </div>

                                    <div className="boxCopysES">
                                        <h4>En proceso</h4>
                                        <p>{copyEnProceso}</p>

                                        <div className="boxBtnEnterado">
                                            <button onClick={redireccionHome}>Enterado</button>
                                        </div>
                                    </div>
                                </div>
                }
            </div>
        </>
    )
}